// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1734":"6534100c","6486":"526f4dde"}[chunkId] + ".chunk.css";
};